import $ from 'jquery'

export default () => {

    const $searchClear = $('#search-main-clear')
    const $searchInput = $('#search-main-input')

    $searchInput.keyup(() => {
        if($searchInput.val() === "") {
            $searchClear.removeClass('is-active')
        } else {
            $searchClear.addClass('is-active')
        }
    })
}
